import HelpTooltip from './HelpTooltip';

export default function ScoreCard({ meta, score }: { meta: any, score: number }) {
    return (
        <div className="bg-white rounded-3xl p-8 shadow-sm border border-slate-200 flex flex-col md:flex-row items-center justify-between gap-6">
            <div className="text-center md:text-left">
                <h2 className="text-slate-500 font-medium tracking-wider text-sm mb-1 flex items-center gap-2">
                    <span className="uppercase">GEO Health Score</span>
                    <HelpTooltip
                        title="GEO Health Score"
                        description="A weighted prediction of how easily AI models can understand and cite your content."
                        benefit="Higher scores correlate with better visibility in ChatGPT and Google AI Overviews."
                    />
                </h2>
                <div className="text-slate-900 font-bold text-xl">{meta.domain}</div>
            </div>
            <div className={`relative flex items-center justify-center w-32 h-32 rounded-full border-8 text-5xl font-black
        ${score >= 80 ? 'border-green-500 text-green-600' :
                    score >= 50 ? 'border-amber-400 text-amber-500' :
                        'border-red-500 text-red-600'}`}>
                {score}
            </div>
        </div>
    );
}
